import * as mathjs from "mathjs";

type GetSummaryCostReturnType = {
  withVat: number;
  withoutVat: number;
  vat: number;
  hasOtherCurrency: boolean;
  hasVat: boolean;
};

export default class TableUtils {
  // Считает общую стоимость в зависимости от ставки, количества и НДС
  static calculateTotalCost({
    vatIncluded,
    cost,
    count,
    vat,
  }: {
    cost?: number;
    count?: number;
    vat?: number | null;
    vatIncluded: boolean;
  }): number | undefined {
    let totalCost;
    if (cost !== undefined && cost !== null && count !== undefined && count !== null) {
      totalCost = vatIncluded || vat === undefined || vat === null || vat === 0 ? cost * count : cost * count + (cost * count * vat) / 100;
    }
    return totalCost === undefined ? undefined : mathjs.round(totalCost, 2);
  }

  static hasVat(vat?: number | null): { hasVat: true; vat: number } | { hasVat: false; vat: undefined } {
    if (vat !== undefined && vat !== null && vat !== 0) {
      return {
        hasVat: true,
        vat,
      };
    }

    return {
      hasVat: false,
      vat: undefined,
    };
  }

  static calculateVats({ cost, vat }: { cost: number; vat: number | null }) {
    const vatCount = vat === null ? 0 : vat;
    const vatValue = mathjs.round((cost * vatCount) / (100 + vatCount), 2);
    const withoutVat = mathjs.round(cost - vatValue, 2);
    return {
      withVat: cost,
      withoutVat,
      vat: vatValue,
    };
  }

  static getSummaryCostValues(
    costs: Array<{ cost?: number; rate?: number; vat?: null | number; nominal: number }>,
  ): GetSummaryCostReturnType {
    return costs.reduce<GetSummaryCostReturnType>(
      (acc, x) => {
        if (x.cost && x.rate) {
          const costWithVat = (x.cost * x.rate) / x.nominal;

          if (x.rate !== 1) {
            acc.hasOtherCurrency = true;
          }

          acc.withVat += costWithVat;

          if (x.vat !== undefined && x.vat !== null && x.vat !== 0) {
            acc.hasVat = true;
            const totalWithoutVat = (costWithVat * 100) / (100 + +x.vat);
            acc.withoutVat += totalWithoutVat;
            acc.vat += costWithVat - totalWithoutVat;
          } else {
            acc.withoutVat += costWithVat;
          }
        }
        return acc;
      },
      {
        withVat: 0,
        withoutVat: 0,
        vat: 0,
        hasOtherCurrency: false,
        hasVat: false,
      },
    );
  }
}
